import { ResourceResponse, ThunkReturnType } from "types";
import type { PayloadAction, WritableDraft } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { getApiStateFromResponse } from "util/api";
import { compareIds } from "util/support";
import type { TransactionResponse, TransactionsResponse, TransactionsState } from "./types";

export const transactionsRequestLoading = (state: WritableDraft<TransactionsState>) => {
    state.tableLoadingState = ApiState.Pending;
};

export const transactionsRequestFulfilled = (
    state: WritableDraft<TransactionsState>,
    { payload }: PayloadAction<ThunkReturnType<TransactionsResponse>>
) => {
    state.tableLoadingState = ApiState.Succeeded;
    state.tableSlice = payload!.data;
};

export const transactionRequestFulfilled = (
    state: WritableDraft<TransactionsState>,
    { payload }: PayloadAction<ThunkReturnType<TransactionResponse>>
) => {
    state.transactionDetailsLoadingState = ApiState.Succeeded;

    const tableSlice = state.tableSlice;

    if (!tableSlice) {
        return;
    }

    state.tableSlice!.data = tableSlice.data.map(transactionEntity => {
        if (compareIds(transactionEntity.coreId, payload!.data.coreId)) {
            return {
                ...transactionEntity,
                ...payload!.data
            };
        }

        return transactionEntity;
    });
};

export const transactionsRequestRejected = (
    state: WritableDraft<TransactionsState>,
    { payload }: PayloadAction<unknown>
) => {
    state.tableLoadingState = getApiStateFromResponse(
        payload as ResourceResponse<null>,
        ApiState.Failed
    );
};
